module.exports = __webpack_public_path__ + "media/images/placeholders/play-button-6f0762436198b48ccf3afa2d9402d59a.png";